var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-layout"},[_c('pc-head',{attrs:{"notHome":_vm.notHome}}),_c('div',{staticClass:"content"},[_vm._t("default")],2),_c('pc-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }